import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import HomeSection from './components/sections/HomeSection';
import AboutSection from './components/sections/AboutSection';
import FeaturesSection from './components/sections/FeaturesSection';
import ComparisonSection from './components/sections/ComparisonSection';
import ReleasesSection from './components/sections/ReleasesSection';
import ScreenshotsSection from './components/sections/ScreenshotsSection';
import FAQSection from './components/sections/FAQSection';
import DownloadSection from './components/sections/DownloadSection';
import TermsSection from './components/sections/TermsSection';

export default function PoppyPokerSite() {
  const [activeTab, setActiveTab] = useState('home');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Handle URL hash routing
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.substring(1);
      if (hash && ['home', 'about', 'features', 'comparison', 'releases', 'screenshots', 'faq', 'download', 'terms'].includes(hash)) {
        setActiveTab(hash);
      }
    };

    // Set initial tab from URL hash
    handleHashChange();

    // Listen for hash changes
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  // Update URL hash when tab changes
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    window.location.hash = tab;
  };


  return (
    <div className="min-h-screen text-white relative" style={{
      background: 'black'
    }}>
      {/* Navigation */}
      <nav className="fixed top-0 w-full bg-black/40 backdrop-blur-md z-50 border-b border-purple-500/30 shadow-lg" style={{
        position: 'fixed',
        top: 0,
        width: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        zIndex: 50,
        borderBottom: '1px solid rgba(147, 51, 234, 0.3)',
        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)'
      }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" style={{
          maxWidth: '80rem',
          marginLeft: 'auto',
          marginRight: 'auto',
          paddingLeft: '1rem',
          paddingRight: '1rem'
        }}>
          <div className="flex justify-between items-center h-16" style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            height: '4rem'
          }}>
            <div className="flex items-center space-x-3">
              <img 
                src="/images/chip.png" 
                alt="Poppy Poker Logo" 
                className="w-10 h-10"
                style={{ width: '2.5rem', height: '2.5rem' }}
              />
              <span className="text-2xl font-bold bg-gradient-to-r from-purple-400 to-purple-600 bg-clip-text text-transparent">Poppy Poker</span>
      </div>
            <div className="hidden md:flex space-x-6">
              <button 
            onClick={() => handleTabChange('home')}
                className={`hover:text-purple-400 transition-colors font-semibold ${activeTab === 'home' ? 'text-purple-400 border-b-2 border-purple-400' : 'text-white'}`}
          >
            Home
              </button>
              <button 
            onClick={() => handleTabChange('about')}
                className={`hover:text-purple-400 transition-colors font-semibold ${activeTab === 'about' ? 'text-purple-400 border-b-2 border-purple-400' : 'text-white'}`}
          >
            About
              </button>
              <button 
                onClick={() => handleTabChange('features')}
                className={`hover:text-purple-400 transition-colors font-semibold ${activeTab === 'features' ? 'text-purple-400 border-b-2 border-purple-400' : 'text-white'}`}
              >
                Features
              </button>
              <button 
                onClick={() => handleTabChange('comparison')}
                className={`hover:text-purple-400 transition-colors font-semibold ${activeTab === 'comparison' ? 'text-purple-400 border-b-2 border-purple-400' : 'text-white'}`}
              >
                Comparison
              </button>
              <button 
                onClick={() => handleTabChange('releases')}
                className={`hover:text-purple-400 transition-colors font-semibold ${activeTab === 'releases' ? 'text-purple-400 border-b-2 border-purple-400' : 'text-white'}`}
              >
                Releases
              </button>
              <button 
                onClick={() => handleTabChange('screenshots')}
                className={`hover:text-purple-400 transition-colors font-semibold ${activeTab === 'screenshots' ? 'text-purple-400 border-b-2 border-purple-400' : 'text-white'}`}
              >
                Screenshots
              </button>
              <button 
                onClick={() => handleTabChange('faq')}
                className={`hover:text-purple-400 transition-colors font-semibold ${activeTab === 'faq' ? 'text-purple-400 border-b-2 border-purple-400' : 'text-white'}`}
              >
                FAQ
              </button>
              <button 
                onClick={() => handleTabChange('download')}
                className={`hover:text-purple-400 transition-colors font-semibold ${activeTab === 'download' ? 'text-purple-400 border-b-2 border-purple-400' : 'text-white'}`}
              >
                Download
              </button>
              <button 
                onClick={() => handleTabChange('terms')}
                className={`hover:text-purple-400 transition-colors font-semibold ${activeTab === 'terms' ? 'text-purple-400 border-b-2 border-purple-400' : 'text-white'}`}
              >
                Terms
              </button>
            </div>
            <div className="md:hidden">
              <button 
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="text-white hover:text-purple-400 transition-colors"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Dropdown */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-black/95 border-b border-purple-500/30 relative z-50 shadow-lg" style={{ position: 'fixed', top: '4rem', left: 0, right: 0 }}>
          <div className="px-4 py-2 space-y-2">
            <button 
              onClick={() => { handleTabChange('home'); setIsMobileMenuOpen(false); }}
              className={`block w-full text-left py-2 px-3 rounded transition-colors font-semibold ${activeTab === 'home' ? 'text-purple-400 bg-purple-400/10' : 'text-white hover:text-purple-400'}`}
            >
              Home
            </button>
            <button 
              onClick={() => { handleTabChange('about'); setIsMobileMenuOpen(false); }}
              className={`block w-full text-left py-2 px-3 rounded transition-colors font-semibold ${activeTab === 'about' ? 'text-purple-400 bg-purple-400/10' : 'text-white hover:text-purple-400'}`}
              style={{ marginTop: '20px' }}
            >
              About
            </button>
            <button 
              onClick={() => { handleTabChange('features'); setIsMobileMenuOpen(false); }}
              className={`block w-full text-left py-2 px-3 rounded transition-colors font-semibold ${activeTab === 'features' ? 'text-purple-400 bg-purple-400/10' : 'text-white hover:text-purple-400'}`}
            >
              Features
            </button>
            <button 
              onClick={() => { handleTabChange('comparison'); setIsMobileMenuOpen(false); }}
              className={`block w-full text-left py-2 px-3 rounded transition-colors font-semibold ${activeTab === 'comparison' ? 'text-purple-400 bg-purple-400/10' : 'text-white hover:text-purple-400'}`}
            >
              Comparison
            </button>
            <button 
              onClick={() => { handleTabChange('releases'); setIsMobileMenuOpen(false); }}
              className={`block w-full text-left py-2 px-3 rounded transition-colors font-semibold ${activeTab === 'releases' ? 'text-purple-400 bg-purple-400/10' : 'text-white hover:text-purple-400'}`}
            >
              Releases
            </button>
            <button 
              onClick={() => { handleTabChange('screenshots'); setIsMobileMenuOpen(false); }}
              className={`block w-full text-left py-2 px-3 rounded transition-colors font-semibold ${activeTab === 'screenshots' ? 'text-purple-400 bg-purple-400/10' : 'text-white hover:text-purple-400'}`}
            >
              Screenshots
            </button>
            <button 
              onClick={() => { handleTabChange('faq'); setIsMobileMenuOpen(false); }}
              className={`block w-full text-left py-2 px-3 rounded transition-colors font-semibold ${activeTab === 'faq' ? 'text-purple-400 bg-purple-400/10' : 'text-white hover:text-purple-400'}`}
            >
              FAQ
            </button>
            <button 
              onClick={() => { handleTabChange('download'); setIsMobileMenuOpen(false); }}
              className={`block w-full text-left py-2 px-3 rounded transition-colors font-semibold ${activeTab === 'download' ? 'text-purple-400 bg-purple-400/10' : 'text-white hover:text-purple-400'}`}
            >
              Download
            </button>
            <button 
              onClick={() => { handleTabChange('terms'); setIsMobileMenuOpen(false); }}
              className={`block w-full text-left py-2 px-3 rounded transition-colors font-semibold ${activeTab === 'terms' ? 'text-purple-400 bg-purple-400/10' : 'text-white hover:text-purple-400'}`}
            >
              Terms
            </button>
          </div>
        </div>
      )}

      {/* Main Content */}
      <main className="pt-16" style={{ paddingTop: '4rem' }}>
      <motion.div
        key={activeTab}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
          {/* Home Section */}
        {activeTab === 'home' && <HomeSection onNavigate={handleTabChange} />}

          {/* Features Section */}
          {activeTab === 'features' && <FeaturesSection />}

          {/* Comparison Section */}
          {activeTab === 'comparison' && <ComparisonSection />}

          {/* Download Section */}
          {activeTab === 'download' && <DownloadSection />}

          {/* Releases Section */}
          {activeTab === 'releases' && <ReleasesSection />}

          {/* Screenshots Section */}
          {activeTab === 'screenshots' && <ScreenshotsSection />}

          {/* FAQ Section */}
          {activeTab === 'faq' && <FAQSection />}

          {/* About Section */}
          {activeTab === 'about' && <AboutSection />}

          {/* Terms Section */}
          {activeTab === 'terms' && <TermsSection />}

        </motion.div>
      </main>

      {/* Footer */}
      <footer className="bg-black/60 border-t border-purple-500/30 py-8">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex items-center space-x-3 mb-4 md:mb-0">
              <img 
                src="/images/chip.png" 
                alt="Poppy Poker Logo" 
                className="w-10 h-10"
                style={{ width: '2.5rem', height: '2.5rem' }}
              />
              <span className="text-2xl font-bold bg-gradient-to-r from-purple-400 to-purple-600 bg-clip-text text-transparent">Poppy Poker</span>
            </div>
            <div className="text-gray-400 text-center md:text-right">
              <p>&copy; 2026 Poppy Poker. All rights reserved.</p>
              <p className="text-sm mt-1">Made with ❤️ for the poker community</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
